<template>
    <div>
        <h1 class="display-heading">Register A New Vaccination Centre Account</h1>

        <div class="row">
            <div class="col-6">
                <h5>Vaccination Centre Details</h5>

                <!-- Name -->
                <div class="form-group">
                    <label>Name</label>
                    <input type="text" name="name" v-model="name" v-validate="'required'" placeholder="Vaccination Centre Name" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('name')
                    }">
                    <div v-show="validationErrors.has('name')" class="invalid-feedback">
                        {{ validationErrors.first('name') }}
                    </div>
                </div>

                <!-- Email -->
                <div class="form-group">
                    <label>Email Address</label>
                    <input type="text" name="email" v-model="email" v-validate="'required'" placeholder="Email" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('email')
                    }">
                    <div v-show="validationErrors.has('email')" class="invalid-feedback">
                        {{ validationErrors.first('email') }}
                    </div>
                </div>

                <!-- Phone -->
                <div class="form-group">
                    <label>Phone</label>
                    <input type="text" name="phone" v-model="phone" v-validate="'required'" placeholder="Phone" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('phone')
                    }">
                    <div v-show="validationErrors.has('phone')" class="invalid-feedback">
                        {{ validationErrors.first('phone') }}
                    </div>
                </div>

                <!-- Password -->
                <div class="form-group">
                    <label>Password</label>

                    <input type="password" name="password" data-vv-validate-on="blur" placeholder="Create a New Password"
                        v-model="password" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('password')
                        }" ref="passwordRef">

                    <div v-show="validationErrors.has('password')" class="invalid-feedback">
                        {{ validationErrors.first('password') }}
                    </div>
                </div>

                <!-- Confrim Password -->
                <div class="form-group">
                    <label>Confirm Password</label>

                    <input type="password" name="repeatPassword" data-vv-validate-on="blur" placeholder="Confirm your password"
                        v-model="repeatPassword" v-validate="'required|confirmed:passwordRef'" data-vv-as="password" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('repeatPassword')
                        }">

                    <div v-show="validationErrors.has('repeatPassword')" class="invalid-feedback">
                        {{ validationErrors.first('repeatPassword') }}
                    </div>
                </div>

                <!-- Region -->
                <div class="form-group">
                    <label>Region</label>
                    <select name="region" data-vv-validate-on="blur" data-vv-as="region"
                        v-model="regionId" value="1" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('region')
                    }">
                        <option v-for="(region, index) in regions" :key="index"
                            :value="region.id">
                            {{region.name}}
                        </option>
                    </select>

                    <div v-show="validationErrors.has('region')" class="invalid-feedback">
                        {{ validationErrors.first('region') }}
                    </div>
                </div>

                <!-- Address 1 -->
                <div class="form-group">
                    <label>Address 1</label>
                    <input type="text" name="address1" v-model="address1" v-validate="'required'" placeholder="Address 1" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('address1')
                    }">
                    <div v-show="validationErrors.has('address1')" class="invalid-feedback">
                        {{ validationErrors.first('address1') }}
                    </div>
                </div>

                <!-- Address 2 -->
                <div class="form-group">
                    <label>Address 2</label>
                    <input type="text" name="address2" v-model="address2" v-validate="'required'" placeholder="Address 2" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('address2')
                    }">
                    <div v-show="validationErrors.has('address2')" class="invalid-feedback">
                        {{ validationErrors.first('address2') }}
                    </div>
                </div>

                <!-- City -->
                <div class="form-group">
                    <label>City</label>
                    <input type="text" name="city" v-model="city" v-validate="'required'" placeholder="City" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('city')
                    }">
                    <div v-show="validationErrors.has('city')" class="invalid-feedback">
                        {{ validationErrors.first('city') }}
                    </div>
                </div>

                <!-- State -->
                <div class="form-group">
                    <label>State</label>
                    <input type="text" name="state" v-model="state" v-validate="'required'" placeholder="State" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('state')
                    }">
                    <div v-show="validationErrors.has('state')" class="invalid-feedback">
                        {{ validationErrors.first('state') }}
                    </div>
                </div>

                <!-- Postcode -->
                <div class="form-group">
                    <label>Postcode</label>
                    <input type="text" name="postcode" v-model="postcode" v-validate="'required'" placeholder="Postcode" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('postcode')
                    }">
                    <div v-show="validationErrors.has('postcode')" class="invalid-feedback">
                        {{ validationErrors.first('postcode') }}
                    </div>
                </div>

                <h5 class="mt-5">Vaccination Centre Payment Details</h5>
                <div class="form-group">
                    <label>Bank Account Payee Name</label>
                    <input type="text" name="bankAccountPayeeName" data-vv-validate-on="blur" data-vv-as="bank account payee name"
                        placeholder="Bank Account Payee Name" v-model="bankAccountPayeeName" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('bankAccountPayeeName')
                    }">
                    <div v-show="validationErrors.has('bankAccountPayeeName')" class="invalid-feedback">
                        {{ validationErrors.first('bankAccountPayeeName') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Bank Name</label>
                    <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name"
                        placeholder="Bank Name" v-model="bankName" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('bankName')
                    }">
                    <div v-show="validationErrors.has('bankName')" class="invalid-feedback">
                        {{ validationErrors.first('bankName') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Bank Account Number</label>
                    <input type="text" name="bankAccountNumber" data-vv-validate-on="blur" data-vv-as="bank account number"
                        placeholder="Bank Account Number" v-model="bankAccountNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('bankAccountNumber')
                    }">
                    <div v-show="validationErrors.has('bankAccountNumber')" class="invalid-feedback">
                        {{ validationErrors.first('bankAccountNumber') }}
                    </div>
                </div>

                <!-- Register -->
                <button type="button" class="btn btn-primary btn-primary-insv mt-2" @click="register">
                    Register Now
                </button>
            </div>
        </div>

        <!-- Pop up modal -->
        <popup-modal ref="popupRegistration" :hasCloseButton="false" :title="popUpTitle">
            <template slot="content">
                <p>{{popUpMessage}}</p>
            </template>
            <template slot="footer">
                <template v-if="isIphAdmin">
                    <button @click="popUpAction" class="btn btn-secondary">{{popUpActionMessage}}</button>
                    <button @click="registerNewVaccinationCentre" class="btn btn-primary btn-primary-insv">Register New</button>
                </template>
                <template v-else>
                    <button @click="popUpAction" class="btn btn-primary btn-primary-insv">{{popUpActionMessage}}</button>
                </template>
            </template>
        </popup-modal>

    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
export default {
    'components': {
        popupModal
    },
    'computed': {
        isIphAdmin () {
            return this.$store.state.user.userRole === 9;
        }
    },
    data () {
        return {
            'name': '',
            'phone': '',
            'email': '',
            'password': '',
            'repeatPassword': '',
            'regionId': 1,
            'address1': '',
            'address2': '',
            'city': '',
            'state': '',
            'postcode': '',
            'bankAccountPayeeName': '',
            'bankName': '',
            'bankAccountNumber': '',
            'regions': [],
            'popUpTitle': '',
            'popUpMessage': '',
            'popUpAction': () => {},
            'popUpActionMessage': ''
        };
    },

    'methods': {
        getRegions () {
            this.axios.get('Region/GetAll?register=true').then((response) => {
                this.regions = response.data.data.regions.map((region) => {
                    return {
                        'id': region.i,
                        'name': region.n
                    };
                });
            });
        },

        async register () {
            // validate
            let validationResult = await this.$validator.validateAll();

            if (validationResult) {
                this.axios.post('/VaccinationCentre/Register', {
                    'n': this.name,
                    'ph': this.phone,
                    'e': this.email,
                    'p': this.password,
                    'cp': this.repeatPassword,
                    'r': this.regionId,
                    'a': {
                        'a1': this.address1,
                        'a2': this.address2,
                        'ac': this.city,
                        'as': this.state,
                        'ap': this.postcode
                    },
                    'bn': this.bankName,
                    'ban': this.bankAccountNumber,
                    'bapn': this.bankAccountPayeeName
                }).then(() => {
                    if (this.isIphAdmin) {
                        this.popUpTitle = 'Registration Success';
                        this.popUpMessage = 'Registration successful, go back to list or register another.';
                        this.popUpAction = this.redirectToList;
                        this.popUpActionMessage = 'Back to List';
                        this.$refs.popupRegistration.show();
                    } else {
                        this.popUpTitle = 'Registration Success';
                        this.popUpMessage = 'Click the button below to proceed with login.';
                        this.popUpAction = this.redirectToLogin;
                        this.popUpActionMessage = 'Login';
                        this.$refs.popupRegistration.show();
                    }
                }).catch((error) => {
                    this.popUpTitle = 'Registration Failed';
                    this.popUpMessage = error.response.data.message;
                    this.popUpAction = this.closePopUp;
                    this.popUpActionMessage = 'Try again';
                    this.$refs.popupRegistration.show();
                });
            }
        },

        redirectToLogin () {
            this.$refs.popupRegistration.hide();
            this.$router.push({
                'name': 'vaccination-centre-login'
            });
        },

        redirectToList () {
            this.$refs.popupRegistration.hide();
            this.$router.push({
                'name': 'admin-vaccination-centres'
            });
        },

        closePopUp () {
            this.$refs.popupRegistration.hide();
        },

        registerNewVaccinationCentre () {
            this.name = '';
            this.phone = '';
            this.email = '';
            this.password = '';
            this.repeatPassword = '';
            this.regionId = 1;
            this.address1 = '';
            this.address2 = '';
            this.city = '';
            this.state = '';
            this.postcode = '';
            this.bankAccountPayeeName = '';
            this.bankName = '';
            this.bankAccountNumber = '';
            this.closePopUp();
        }
    },

    mounted () {
        this.getRegions();
    }
};
</script>
